<style src="css/eBookDetail.css" scoped></style>
<template>
  <div style="padding-top: 0.98rem;background:#fff">
    <topbar text="电子书"></topbar>
    <div class="main">
      <div class="topBox">
        <img :src="EnvUrl + detail.bookPic" alt="" class="itemIcon" />
        <div class="itemRight">
          <div>
            <div class="itemTitle">{{ detail.title }}</div>
            <div class="itemTagline">{{ detail.tagline }}</div>
          </div>

          <div class="itemBottomBox">
            <div class="num">共{{ detail.catalogCount }}章</div>
            <div class="num">{{ detail.readCount }}人学习</div>
          </div>
        </div>
      </div>
      <div class="title">简介</div>
      <div class="content" v-html="detail.content"></div>
      <div class="title">目录</div>
      <div class="catalogueList">
          <div class="catalogueItem" v-for="(item,index) in list" :key="index" @click="change(item.catalogId)">
              {{item.catalogName}}
              <img src="~assets/cr_lock.png" class="lock" alt="" v-if="!(detail.payType==0||orderNo)">
          </div>
      </div>
    </div>
    <div class="btnBox">
        <div class="btn" v-if="!(detail.payType==0||orderNo)" @click="showMask">购买书单 ￥{{detail.bookPrice}}</div>
        <div class="btn" v-else @click="to">立即阅读</div>
    </div>
    <pay v-if="mask" @close="closeMask" :price="detail.bookPrice" microId="" :bookId="detail.bookId"></pay>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import pay from "components/payAssembly"
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";
import Pay from './pay.vue';

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      bookId: "",
      catalogId:'',
      catalogName:"",
      detail: {},
      mask:false,
      orderNo:'',
      list:[]
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
    pay,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    showMask(){
      this.mask=true
    },
    closeMask(){
      this.mask=false;
    },
    change(id){
      if(this.detail.payType==0||this.orderNo){
        this.catalogId = id;
        this.to()
      }
    },
    to(id) {
      this.$router.push(`/eBookWord?bookId=${this.bookId}&catalogId=${this.catalogId}&catalogName=${this.catalogName}&orderNo=${this.orderNo}`);
    },
    async getDetail() {
      let obj = {};
      obj.bookId = this.bookId;
      obj.userId = this.userId;
      obj.companyId = localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "";
      let data = await getSources(
        "/bear-scale/api/microBook/getBookDetail",
        obj
      );
      if (data.status === 0) {
        this.detail = data.bookInfo;
        this.list = data.catalogList;
        this.catalogId = data.catalogList[0].catalogId;
        this.catalogName = data.catalogList[0].catalogName
      } else {
        alert(data.msg);
      }
    },
  },
  destroyed() {},
  mounted() {
    if (!localStorage.getItem("userId")) {
      if (this.$route.query.code) {
        this.$router.push(
          `/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${
            this.$route.query.code
          }`
        );
      } else {
        this.$router.push(
          `/login?next=${encodeURIComponent(this.$route.fullPath)}`
        );
      }
      return;
    }
    this.userId = localStorage.getItem("userId");
    this.bookId = this.$route.query.id;
    this.orderNo = this.$route.query.orderNo?this.$route.query.orderNo:''
    this.getDetail();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/eBookDetail.vue?6503e830